import {
  Box,
  CircularProgress,
  CircularProgressLabel,
  HStack,
  Icon,
  Spacer,
  Stack,
  Step,
  StepIcon,
  StepIndicator,
  StepNumber,
  Stepper,
  StepSeparator,
  StepStatus,
  StepTitle,
  Text
} from '@chakra-ui/react';

import { ForaLogoIcon } from '@assets/icons';
import { useBreakpoints } from '@util/hooks';

/**
 * @param {Object} props
 * @param {OnboardingStep[]} props.steps
 * @param {number} props.activeStep
 */
const OnboardingHeader = ({ steps, activeStep }) => {
  const { isMobile } = useBreakpoints();
  const progressValue = (100 / steps.length) * (activeStep + 1);

  if (isMobile) {
    return (
      <HStack
        data-testid='onboarding-mobile-header'
        w='full'
        p={4}
        gap={8}
      >
        <CircularProgress
          data-testid='onboarding-progress-circle'
          size='96px'
          color='brandPrimary.primary'
          value={progressValue}
        >
          <CircularProgressLabel>
            <Text variant='title-md'>
              {activeStep + 1} of {steps.length}
            </Text>
          </CircularProgressLabel>
        </CircularProgress>
        <Spacer />
        <Stack
          gap={1}
          align='end'
        >
          <Text
            variant='headline-md'
            data-testid='onboarding-active-step'
          >
            {steps[activeStep].label}
          </Text>
          {steps?.[activeStep + 1] && (
            <Text
              color='surface.onSurfaceVariant'
              data-testid='onboarding-next-step'
            >
              Next: {steps?.[activeStep + 1].label}
            </Text>
          )}
        </Stack>
      </HStack>
    );
  }

  return (
    <HStack
      data-testid='onboarding-desktop-header'
      gap={16}
      w='full'
      px={16}
    >
      <Icon
        as={ForaLogoIcon}
        color='brandPrimary.primary'
        boxSize={24}
      />
      <Stepper
        index={activeStep}
        w='full'
      >
        {steps.map((step) => (
          <Step key={step.label}>
            <StepIndicator>
              <StepStatus
                complete={<StepIcon />}
                incomplete={<StepNumber />}
                active={<StepNumber />}
              />
            </StepIndicator>

            <Box flexShrink='0'>
              <StepTitle>{step.label}</StepTitle>
            </Box>

            <StepSeparator />
          </Step>
        ))}
      </Stepper>
    </HStack>
  );
};

export default OnboardingHeader;
